import Lugia from './core/rest-template'
import ElementRenderer from './renderer/element-renderer'
import { provider } from './hooks/use-provider'
import { App } from 'vue'
import AbstractResponseAdapter from './adapters/base/abstract-response-adapter'
import AbstractHttpAdapter from './adapters/base/abstact-http-adapter'
import AbstractPageAdapter from './adapters/base/abstract-page-adapter'
import SampleHttpAdapter from '@/adapters/impl/sample-http-adapter'
import SampleResponseAdapter from '@/adapters/impl/sample-response-adapter'
import SamplePageAdapter from '@/adapters/impl/sample-page-adapter'

const install = (app: App): void => {
  app.component(Lugia.name, Lugia)
}
export default {
  install,
  provider
}
export {
  Lugia,
  ElementRenderer,
  AbstractResponseAdapter,
  AbstractHttpAdapter,
  AbstractPageAdapter,
  SampleHttpAdapter,
  SampleResponseAdapter,
  SamplePageAdapter
}
export * from './types'
export * from './enum'
